import IziToast from "izitoast";
import currencyService from "../services/currency.service";
import pushService from "../services/push.service";

export default {
  install: (Vue, { router, messagesRoute }) => {    
    Vue.$notification = {
      push(message) {
        let title = Vue.i18n.translate(`notification.${message.type}`);
        if (message.amount && message.currency) {
          title += ' ' + currencyService.format(message.amount, message.currency);
        }
        title += '!';

        const getColor = (message)  => {
          if (message && message.type.includes('Declined'))
            return 'yellow'

          if (message && message.type == 'DepositLocked')
            return 'red';
      
          return 'green';
        }

        IziToast.show({
          title: title,
          theme: 'light',
          color: getColor(message),
          position: 'topRight',
          transitionIn: 'bounceInLeft',
          timeout: false,
          drag: false,
          progressBar: false,
          closeOnClick: true,
          buttons: [
            [`<button>${Vue.i18n.translate('notification.see all')}</button>`, function (instance, toast) { router.push(messagesRoute || "/profile/messages"); }],
            [`<button>${Vue.i18n.translate('notification.close')}</button>`, function (instance, toast) { pushService.setAllRead(); }]
          ]
        });
      }
    };
  }
}



// WEBPACK FOOTER //
// ./_common/plugins/notification.plugin.js